<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title" v-if="!arquivado">
            Lockers
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
          <h4 class="card-title" v-if="arquivado">
            Lockers arquivados
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
        </div>
          <l-button wide type="primary" 
            style="margin-left: 5px; float: right;"
            round v-if="showItem" @click="cloneDialog = true">
            <span class="btn-label">
              <i class="fa fa-plus" style="margin-right: 5px; margin-top: 3px"></i>
            </span>
            Clonar
          </l-button>
          <router-link to="/app/machines/locker">
            <l-button wide type="primary" round v-if="showItem"
              style=" float: right; ">
              <span class="btn-label">
                <i class="fa fa-plus" style="margin-right: 5px; margin-top: 3px"></i>
              </span>
              Criar
            </l-button>
          </router-link>

        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
            <div class="col-sm-12" style="margin-top: 10px">
            <el-checkbox v-model="arquivado">Locker arquivada</el-checkbox>
              <!-- <label class="col-sm-6">Maquina</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="vendMachine"
              >
                <el-option
                  v-for="maq in machines"
                  class="select-danger"
                  :value="maq.id"
                  :label="maq.location"
                  :key="maq.id"
                ></el-option>
              </el-select> -->
            </div>
            <!-- <div class="col-sm-11" style="margin-top: 10px">
              <label class="col-sm-6">Periodo</label>
              <el-date-picker
                style="margin-left: 15px"
                v-model="date_init"
                type="daterange"
                format="dd/MM/yyyy"
                align="right"
                unlink-panels
                range-separator="a"
                start-placeholder="Data de início"
                end-placeholder="Data final">
              </el-date-picker>
            </div> -->
          </card>
          <!-- <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp; -->
          <button class="btn btn-success" @click="filtro = false">OK</button>
        </el-dialog>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData" v-loading="loading">
            <el-table-column label="Local" property="location" min-width="180" sortable/>
            <el-table-column label="Filial" property="company_name" min-width="180" sortable v-if="showMatriz"/>
            <el-table-column label="Usuário" property="user" min-width="160" sortable/>
            <el-table-column label="Endereço IP" property="ip" width="240" />
            <el-table-column label="Atualizado em" property="last_communication" width="180" sortable/>
            <el-table-column label="Ações" width="140">
              <div class="td-actions" slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Configurações" placement="top-start">
                  <a
                    v-if="permission('config_vm') && !props.row.archived || showMatriz"
                    class="btn btn-info btn-link btn-xs"
                    @click="handleDoors(props.$index, props.row)"
                  >
                    <i class="fa fa-gear"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Planograma" placement="top-start">
                  <a
                    v-if="permission('adjustment_vm') && !props.row.archived || showMatriz"
                    class="btn btn-success btn-link btn-xs"
                    @click="handleShelves(props.$index, props.row)"
                  >
                    <i class="fa fa-wrench"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                  <a
                    v-if="$store.state.auth.imach  && !props.row.archived"
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="!props.row.archived"
                  content="Arquivar" placement="top-start">
                  <a
                    v-if="permission('delete_vm')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDelete(props.$index, props.row)"
                  >
                    <i class="fa fa-folder"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" v-if="props.row.archived"
                  content="Desarquivar" placement="top-start">
                  <a
                    v-if="permission('delete_vm')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDeleteOff(props.$index, props.row)"
                  >
                    <i class="fa fa-folder-open"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
      <el-dialog center :visible.sync="cloneDialog" title="Clonar máquina">
        <card class="row">
          <form class="form-horizontal">
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6" style="margin-left: -6px" >Maquina ou Locker</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="cloneVM"
              >
                <el-option
                  v-for="maq in lockersAPI"
                  class="select-danger"
                  :value="maq.id"
                  :label="maq.location"
                  :key="maq.id"
                ></el-option>
              </el-select>
              <div style="margin-left: 6px">
                <fg-input
                  name="name"
                  label="Nome"
                  v-model="name"
                ></fg-input>
                <fg-input
                  name="Local"
                  label="Local"
                  v-model="location"
                ></fg-input>
              </div>
            </div>
          </form>
        </card>
        <button class="btn btn-danger offset-sm-8" @click="cloneDialog = false">Cancelar</button>&nbsp;
        <el-button 
              :loading="btnLoading"
              type="success"
              style="font-size: 1em; float: right;"
              @click="clonar()"
              > Clonar!</el-button>
        <!-- <button class="btn btn-success" @click="clonar()">Clonar!</button> -->
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Loading,
  Tooltip,
  Checkbox
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Checkbox.name]: Checkbox,
  },
    data () {
      return {
        filtro: false,
        produto: [],
        tipo: [],
        prateleira: [],
        vendMachine: [],
        date_init: [],
        lockers: [],
        products: [],
        machines: [],
        showTable: true,
        lockersAPI: [],
        totalResults: 30,
        pesquisa: '',
        page: 1,
        pageSize: 10,
        order: false,
        loading: true,
        btnLoading: false,
        sord: '',
        cloneDialog: false,
        arquivado: false,
        cloneVM: '',
        name: '',
        location: '',
        ciaID: ''
      }
    },
    mounted () {
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.ciaID = ciaID
      this.$watch('arquivado', ()=>{
        this.getData(ciaID)
      })
    },
  computed: {
    tableData() {
      const lockers = this.$store.state.lockers.lockers;
      console.log('locks', lockers)
      const dateConverted = lockers.map(v => {
        let user
        const d = new Date(v.last_communication);
        const last_communication = d.toLocaleString("pt-BR");
        
        if (v.user) {
          user = this.$store.state.general.listUser.user_list_info.find(e => e.id == v.user)
          user = user.username
        }
        return { ...v, last_communication, user };
      });
      return dateConverted;
    },
    productsName() {
      return this.$store.state.products.products;
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    movimentos() {
      return [{ value: "E", label: "Entrada" }, { value: "S", label: "Saida" }];
    },
    shelf() {
      var seenNumber = {};

      var fil = this.$store.state.lockers.lockers.filter(function(
        currentObject
      ) {
        if (currentObject.shelf in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.shelf] = true;
          return true;
        }
      });
      return fil;
    },
  },
  created() {
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === 'vm') {
        x.prop = 'vm__location'
      }
      if (x.prop === 'product') {
        x.prop = 'product__name'
      }
      this.sord = sinal + x.prop
      this.getData()
    },
    handleShelves(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/locker/${row.id}/boxes`);
    },
    handleDoors(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/locker/${row.id}/maintenance`);
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/locker/${row.id}`);
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = row.location;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a arquivar o locker ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, arquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("lockers/updatePatch", { item : {
                                                                  id: row.id,
                                                                  archived: true
                                                                  } }).then(res => {
            if (res.status !== 500) {
              swal.fire({
                title: "Pronto!",
                text: `${itemName} arquivada.`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              this.getData(this.ciaID)
            } else {
              swal.fire({
                title: "Ops!",
                text: `${itemName} não arquivada.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não arquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    handleDeleteOff(i, row) {
      console.log(row);
      const itemName = row.location;
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a desarquivar o locker ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, desarquive!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("lockers/updatePatch", { item : {
                                                                  id: row.id,
                                                                  archived: false
                                                                  } }).then(res => {
            if (res.status !== 500) {
              swal.fire({
                title: "Pronto!",
                text: `${itemName} desarquivada.`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              this.getData(this.ciaID)
            } else {
              swal.fire({
                title: "Ops!",
                text: `${itemName} não desarquivada.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não desarquivada.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      this.getData()
    },
    permission (permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
        if (el == permissao) {
          return true
        } 
      })
      if (x.length > 0) {
        return true
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    filtragem () {
      this.lockers = this.lockersAPI
      var date = []
      this.pesquisa = ''
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.pesquisa = this.pesquisa + "&company=" + ciaID
      } 

      if (this.produto) {
        this.pesquisa = this.pesquisa + '&product=' + this.produto
      }
      if (this.tipo) {
        this.pesquisa = this.pesquisa + "&movement_type=" + this.tipo
      }
      if (this.vendMachine) {
        this.pesquisa = this.pesquisa + "&vm=" + this.vendMachine
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisa = this.pesquisa + '&created__range=' + date[0] + '%2C' + date[1]
      }
      this.getData()
      this.filtro = false;
    },
    clearFiltro() {
      this.getData();
      this.produto = "";
      this.tipo = "";
      this.prateleira = "";
      this.vendMachine = "";
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      this.date_init = []
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Criado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Criado!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    clonar () {
      if(this.name && this.location && this.cloneVM) {
        this.btnLoading = true
        this.$store.dispatch('lockers/clone_locker', { id: this.cloneVM, data: {
          location : this.location,
          name : this.name
        }}).then (data => {
          console.log('data', data)
          if (data.status == 201) {
            this.notifySuccess();
            this.getData()
            this.btnLoading = false
            this.cloneDialog = false
          } else {
            this.notifyError()
            this.cloneDialog = false
            this.btnLoading = false
          }
        })
      } else {
        alert('Preencha todos os campos.')
      }
    },
    report() {
      if (this.totalResults > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResults + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        this.pesquisa = this.pesquisa.replace('&','?')
        this.$store.dispatch('general/excelMovement', {search: this.pesquisa}).then(data => {
          this.btnLoading = data
        })
      }
    },
    getData (id) {
      this.loading = true
      if (id) { 
        id = id
      } else {
        id = ''
      }
        this.$store.dispatch('general/listUser').then(() => {
            this.$store.dispatch("lockers/listSort", {sort: '?page_size=' + this.pageSize
                  + '&page=' + this.page + '&company=' + id + '&archived=' + this.arquivado
                  + '&ordering=' + this.sord + this.pesquisa}).then(resp => {
                  this.totalResults = this.$store.state.lockers.page.count
                  this.lockers = resp
                  this.lockersAPI = resp
                  this.loading = false
                  console.log('total', this.totalResults)
                  console.log('store', this.$store.state)
                }).catch(err => console.log(err));
        }).catch(err => console.log(err));
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
